export default __webpack_public_path__ + "static/media/secure-roofing-and-solar-logo.2fdd1232.webp";